<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      p.text-center(style="margin-bottom:32px;")
        | WirForce 2015 以爆發性五倍成長再創顛峰，BYOC 參與數達 400 人，集結 12 家國內外知名廠商，總來場人數超過 2 萬人次，全程活動實況締造超過 75 萬不重複觀看人次，總曝光觸及人數超過 2,000 萬！
        br
        br
        | WirForce 2016 BYOC 參與數達 600 人，總來場人數超過 7 萬人次，全程活動實況締造超過 100 萬以上不重複觀看人次，總曝光觸及人數超過 3,000 萬！!
    section
      .tab-wrap
        .tab-item(v-for="(tab, index) in tabs", @click="tabSelect(index)", :class="{actived: nowTab === index}") {{ tab.name}}
    .mb-10
    section(v-if="nowTab === 0")
      .section-title 2015
      .mb-4
        .news-wrap(v-for="post in news.y2015")
          a(:href="post.link", target="_blank").news-item
            .left
              img(src="~assets/logo-frame.svg")
              .time {{ post.time }}
            .right
              .title {{ post.title }}
              .description {{ post.publisher }}
    section(v-if="nowTab === 1")
      .section-title 2016
      .mb-4
        .news-wrap(v-for="post in news.y2016")
          a(:href="post.link", target="_blank").news-item
            .left
              img(src="~assets/logo-frame.svg")
              .time {{ post.time }}
            .right
              .title {{ post.title }}
              .description {{ post.publisher }}
    section(v-if="nowTab === 2")
      .section-title 4Gamers 站內新聞
      .mb-4
        .news-wrap(v-for="post in getNews.data")
          a(:href="'https://www.4gamers.com.tw/news/detail/' + post.news_id + '/' + post.url_string", target="_blank").news-item
            .left
              img(src="~assets/logo-frame.svg")
              //- .time(v-if="!newsLoading") {{ post.created_at | moment}}
              .time(v-if="!newsLoading") {{ post.created_at | moment-news}}
              .time(v-else)
                .spinner
                  .bounce.bounce1
                  .bounce.bounce2
                  .bounce.bounce3
            .right
              .title(v-if="!newsLoading") {{ post.title }}
              .title(v-else)
                .spinner
                  .bounce.bounce1
                  .bounce.bounce2
                  .bounce.bounce3
              .description 4Gamers
        .pagination(v-if="getNews.meta")
          .btn.ghost-btn(@click="prePage", :disabled="newsPage === 1") 上一頁
          .currentPage
            span.now {{ getNews.meta._paginator.current_page }}
            span.last / {{ getNews.meta._paginator.last_page }}
          .btn.ghost-btn(@click="nextPage", :disabled="newsPage === getNews.meta._paginator.last_page") 下一頁
    .mb-40
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'news',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.newsLoading = true
      vm.fetchNews(vm.newsPage).then((data) => {
        vm.newsLoading = false
      })
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      newsPage: 1,
      newsLoading: false,
      nowTab: 2,
      tabs: [
        {
          name: '2015'
        },
        {
          name: '2016'
        },
        {
          name: '4Gamers 站內新聞',
          link: 'https://www.4gamers.com.tw/news/tag/WirForce2016'
        }
      ],
      news: {
        'y2015': [
          {
            link: 'https://2016.wirforce.com.tw/25.html',
            time: '2014/8/20',
            title: '《WirForce》連結臺灣電競社群，WirForce 促進臺灣電競產業升級',
            publisher: '鐵人論壇'
          },
          {
            link: 'https://2016.wirforce.com.tw/24.html',
            time: '2014/8/20',
            title: '《WirForce》展現社群武力！絕不能錯過的夢幻 Lan Party',
            publisher: '臺灣星盟電競情報網'
          },
          {
            link: 'https://2016.wirforce.com.tw/23.html',
            time: '2014/8/20',
            title: '【更新】WirForce 電競盛會開幕　',
            publisher: '蘋果即時'
          },
          {
            link: 'http://www.appledaily.com.tw/realtimenews/article/3c/20140830/461047/apples…A5%E5%90%8D%E5%AF%A6%E6%B3%81%E4%B8%BB%E5%B8%B6%E9%A0%AD%E5%97%A8%E3%80%80',
            time: '2014/8/20',
            title: '正妹玩遊戲　知名實況主帶頭嗨',
            publisher: '蘋果即時'
          },
          {
            link: 'http://www.appledaily.com.tw/realtimenews/article/3c/20140830/460889/apples…%B4%E6%93%8AWirForce%E9%9B%BB%E7%AB%B6%E7%9B%9B%E6%9C%83%E5%85%A7%E9%83%A8',
            time: '2014/8/20',
            title: '玩家專屬　直擊 WirForce 電競盛會內部',
            publisher: '蘋果即時'
          },
          {
            link: 'http://t17.techbang.com/topics/29172-taiwan-first-chun-raise-activity-of-esports-wirforce-lanparty-alcohol-electronic-electro-not-to-be-missed',
            time: '2014/9/1',
            title: '[討論] 臺灣首場電競春吶活動紀實，WirForce Lanparty，酒精、電音、電競豈能錯過。',
            publisher: 'T17'
          },
          {
            link: 'http://www.appledaily.com.tw/realtimenews/article/facebook/20140901/461875/…%A3%E9%A6%96%E5%A0%B4LanParty%E5%9C%93%E6%BB%BF%E6%88%90%E5%8A%9F%EF%BC%81',
            time: '2014/9/1',
            title: '【電腦王阿達】各界促成臺灣首場 Lan Party 圓滿成功！',
            publisher: '蘋果即時'
          },
          {
            link: 'https://www.kocpc.com.tw/archives/7744#more-7744',
            time: '2014/9/1',
            title: '電競界的春天吶喊：WirForce Lan Party 臺灣始動！',
            publisher: '電腦王阿達'
          },
          {
            link: 'http://www.ironforum.com.tw/newsdetail/1503/1',
            time: '2014/9/6',
            title: '《WirForce》LAN Party 鍵盤遊！WirForce 總覽圖集秀',
            publisher: '鐵人論壇'
          },
          {
            link: 'http://gameplayer.mabee88.com/QKNEWS.aspx?id=829',
            time: '2014/9/13',
            title: 'Wirforce Lanparty 全都賣！《 WWE 2K14 》精彩實況整理串 ',
            publisher: 'QK電玩咖'
          },
          {
            link: 'https://www.cool3c.com/article/94060',
            time: '2015/7/27',
            title: '亞洲最大電競連線派對 WirForce Powered by NVIDIA 將在五股工商展覽館盛大舉辦',
            publisher: '隱科技'
          },
          {
            link: 'http://www.chinatimes.com/realtimenews/20150728002415-260410',
            time: '2015/7/28',
            title: '《科技》WirForce 電競盛會，9 月 Hight 起來',
            publisher: '中時電子報'
          },
          {
            link: 'http://bbs.flash2u.com.tw/dispbbs_175_809268_1.html',
            time: '2015/7/28',
            title: '亞洲 Lan Party「WirForce 2015」預定 9 月 18 日在新北市登場',
            publisher: 'GNN'
          },
          {
            link: 'http://www.u-acg.com/archives/5564',
            time: '2015/9/13',
            title: '贈票｜WIRFORCE 2015 臺灣場，一起來打個三天兩夜吧！',
            publisher: 'UACG'
          },
          {
            link: 'http://game.ettoday.net/article/564427.htm',
            time: '2015/9/14',
            title: '東南亞最大 LAN Party 盛會「 WirForce 」本週末五股開跑',
            publisher: '東森新聞'
          },
          {
            link: 'http://3c.technews.tw/2015/09/15/lan-party-wirforce-2015-septermer-18-in-taiwan/',
            time: '2015/9/15',
            title: 'WirForce 2015 週末登場，LAN Party 電競盛會倒數計時',
            publisher: '3C新報'
          },
          {
            link: 'https://tw.news.yahoo.com/%E6%B6%88%E8%B2%BB%E5%BF%AB%E8%A8%8A-%E6%9D%B1%E5…rty-%E5%91%A8%E4%BA%94%E8%B5%B7%E9%80%A3%E8%BE%A63%E5%A4%A9-215008427.html',
            time: '2015/9/15',
            title: '消費快訊－東南亞最大電競盛會 LAN Party 週五起連辦3天',
            publisher: '中時電子報'
          },
          {
            link: 'https://www.pcmarket.com.hk/2015/09/18/%E4%BA%9E%E6%B4%B2%E6%9C%80%E5%A4%A7…BB%E7%AB%B6%E6%B4%BB%E5%8B%95wirforce%E7%81%AB%E7%86%B1%E8%B5%B7%E5%8B%95/',
            time: '2015/9/18',
            title: '亞洲最大電競活動 WIRFORCE 火熱起動',
            publisher: 'PCM'
          },
          {
            link: 'https://www.computerdiy.com.tw/wirforce-2015-lan-party-byoc/',
            time: '2015/9/19',
            title: 'Wirforce 2015 LAN Party/BYOC 電競盛事 朝聖請早',
            publisher: '電腦DIY'
          },
          {
            link: 'http://www.ironforum.com.tw/newsdetail/2375/1',
            time: '2015/9/19',
            title: '《 WirForce 》亞州最大 LanParty，9月18日五股盛大開幕',
            publisher: '鐵人論壇'
          },
          {
            link: 'https://www.cool3c.com/article/96253',
            time: '2015/9/19',
            title: '400 電玩鐵咖三天兩夜挑燈夜戰，亞洲最大 Lan Party WirForce 2015 開跑',
            publisher: '隱科技'
          },
          {
            link: 'http://www.chinatimes.com/realtimenews/20150920000005-260412',
            time: '2015/9/20',
            title: 'WirForce 2015 電競派對 ROG 小護士護眼操萌度破表',
            publisher: '中時電子報'
          },
          {
            link: 'http://www.mofang.com.tw/INnews/10000054-10078612-1.html',
            time: '2015/9/23',
            title: 'WirForce 2015 Lan Party 搶先曝光',
            publisher: '魔方網'
          },
          {
            link: 'http://zeekmagazine.com/archives/18733',
            time: '2015/9/23',
            title: '亞洲最大電競盛會 WirForce 2015 引領臺灣前進世界！',
            publisher: 'ZEEK玩家誌'
          },
          {
            link: 'http://agirls.aotter.net/?p=27726',
            time: '2015/9/24',
            title: '[出門] 連續三天的 LAN Party 網路派對★「 WirForce 2015 」一起通宵打電動吧!',
            publisher: '電獺少女'
          },
          {
            link: 'http://money.udn.com/money/story/5640/1218042-Lan-Party%E7%8E%A9%E5%AE%B6%E7%86%B1%E8%A1%80%E9%9F%BF%E6%87%89',
            time: '2015/9/30',
            title: 'Lan Party 玩家熱血響應',
            publisher: '聯合財經網'
          }
        ],
        'y2016': [
          {
            link: 'http://www.setn.com/News.aspx?NewsID=197422',
            time: '2016/11/13',
            title: '80小時WirForce即將閉幕　不玩遊戲就去拿贈品！',
            publisher: 'SETN三立新聞網'
          },
          {
            link: 'http://www.appledaily.com.tw/realtimenews/article/new/20161110/985707',
            time: '2016/11/10',
            title: '【爽玩片】80小時不睡　7萬人將在花博公園嗨什麼',
            publisher: '蘋果即時'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  },
  methods: {
    tabSelect (index) {
      this.nowTab = index
    },
    prePage () {
      let preNum = this.getNews.meta._paginator.current_page - 1
      this.newsLoading = true
      if (this.getNews.meta._paginator.current_page > 1) {
        this.nowTab = 2
        this.fetchNews(preNum).then((data) => {
          this.newsLoading = false
        })
        this.newsPage = preNum
      }
    },
    nextPage () {
      let nextNum = this.getNews.meta._paginator.current_page + 1
      this.newsLoading = true
      if (this.getNews.meta._paginator.current_page < this.getNews.meta._paginator.last_page) {
        this.nowTab = 2
        this.fetchNews(nextNum).then((data) => {
          this.newsLoading = false
        })
        this.newsPage = nextNum
      }
    },
    ...mapActions([
      'fetchNews'
    ])
  },
  mounted () {
    this.news.y2015.reverse()
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.tab-wrap
  .tab-item
    &.actived
      color: #fff
.news-wrap
  .news-item
    display: block
    border: 1px solid #fff
    +border-radius(6px)
    margin-bottom: 14px
    padding: 12px 27px
    @extend %clearfix
    +transition(all, 0.3s, ease)
    .left
      float: left
      margin-right: 24px
      width: 60px
      @extend %clearfix
      @media screen and (max-width: 990px)
        width: 100%
      img
        margin-top: 3px
        margin-bottom: 6px
        width: 60px
        @media screen and (max-width: 990px)
          display: none
      .time
        color: $grey
        font-weight: bold
    .right
      float: left
      width: calc(100% - 84px)
      @extend %clearfix
      @media screen and (max-width: 990px)
        width: 100%
      .title
        font-size: 20px
        color: #fff
        margin-bottom: 14px
      .description
        color: $red-light
        @media screen and (max-width: 990px)
          float: right
    &:hover
      border: 1px solid $red
      box-shadow: inset 0 0 10px 1px $red

.pagination
  position: relative
  left: 50%
  +transform(translateX(-50%))
  .ghost-btn
    display: inline-block
  .currentPage
    display: inline-block
    border: 1px solid #fff
    padding: 6px 12px
    margin: 0 16px
    .now
      font-size: 18px
      margin-right: 4px
    .last
      font-size: 13px
      color: $grey
</style>



// WEBPACK FOOTER //
// news.vue?222adfdd